import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useInfrastructureContext } from './InfrastructureContext';
import { trackClick } from './tracking';
import { setIsDropdownOpen } from '../../../../Map/actions/infrastructure/setIsDropdownOpen';
import {
  selectActiveType,
  selectIsDropdownOpen,
  selectIsInfrastructureOnMapEnabled,
  selectTypes,
} from '../../../../Map/selectors';
import { InfrastructureButton } from '../../../components/Navigation/Infrastructure';
import { useIsDailyrentDesktopHybridExpActive } from '../../../hooks/useIsDailyrentDesktopHybridExpActive';
import { TThunkDispatch } from '../../../types/redux';

export function InfrastructureControlContainer() {
  const isOpen = useSelector(selectIsDropdownOpen);

  const dispatch = useDispatch<TThunkDispatch>();
  const activeLayer = useSelector(selectActiveType);
  const layers = useSelector(selectTypes);
  const isInfrastructureOnMapEnabled = useSelector(selectIsInfrastructureOnMapEnabled);

  const isHybridExpActive = useIsDailyrentDesktopHybridExpActive();

  const { infrastructureButtonRef } = useInfrastructureContext();

  const handleClick = React.useCallback(() => {
    if (!isOpen) {
      trackClick();
    }
    dispatch(setIsDropdownOpen(!isOpen));
  }, [isOpen]);

  if (isHybridExpActive || !isInfrastructureOnMapEnabled || layers.length === 0) {
    return null;
  }

  return (
    <InfrastructureButton
      ref={infrastructureButtonRef}
      title={activeLayer?.name}
      expanded={isOpen}
      onClick={handleClick}
    />
  );
}
